import { useMediaQuery } from 'usehooks-ts';
import tailwindConfigFile from 'tailwind.config';
import resolveConfig from 'tailwindcss/resolveConfig';

const DEFAULT_BREAKPOINT = 'lg';

export const useDeviceType = () => {
  const breakpointKey = DEFAULT_BREAKPOINT;
  const tailwindConfig = resolveConfig(tailwindConfigFile);
  const tailwindBreakpoint = Number(
    tailwindConfig.theme.screens[breakpointKey].substring(0, tailwindConfig.theme.screens[breakpointKey].indexOf('px')),
  );
  const isDesktop = useMediaQuery(`(min-width: ${tailwindBreakpoint}px)`);
  return { isDesktop };
};
